import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function Head(props) {
  return (
    <head>
      <meta charset="utf-8" />
      <meta property="op:markup_version" content="v1.0" />
      <link rel="canonical" href={props.canonical} />
      <meta name="robots" content="noindex" />
      <meta property="fb:use_automatic_ad_placement" content="true" />
      <link rel="stylesheet" title="default" href="#" />
    </head>
  );
}

function mapStateToProps(state) {
  return {
    canonical: state.config.navHistory[0].split('?')[0],
    staticUrl: state.config.staticUrl,
    meta: state.meta,
    initialPageLoad: state.config.initialPageLoad
  };
}

Head.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  meta: PropTypes.shape({}).isRequired,
  canonical: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(Head);
